module.exports = __webpack_public_path__ + "static/media/ver_mapa.d5411bfe.jpg";